// import React from 'react';
// import './PracticeDetails.css';

// const PracticeDetails = ({ practiceData }) => {
//   if (!practiceData) {
//     return (
//       <div className="practice-details-alert practice-details-alert-info" role="alert">
//         No practice data available.
//       </div>
//     );
//   }

//   // Get status badge class based on status
//   const getStatusBadgeClass = (status) => {
//     if (!status || typeof status !== 'string') {
//       return 'practicetotal';
//     }
//     switch (status.toLowerCase()) {
//       case 'active':
//         return 'practiceactive';
//       case 'pending':
//         return 'practicepending';
//       case 'locked':
//         return 'practicelocked';
//       case 'inactive':
//         return 'practicelocked';
//       default:
//         return 'practicetotal';
//     }
//   };

//   return (
//     <div className="practice-details">
//       {/* Primary and Secondary Contact Section */}
//       <div className="practice-details-contact-section">
//         <div className="row">
//           {/* Primary Contact */}
//           <div className="col-md-6">
//             <div className="practice-details-contact-card">
//               <h5>Primary Contact</h5>

//               <div className="practice-details-info-row">
//                 <span className="practice-details-info-label">Facility</span>
//                 <span className="practice-details-info-separator">:</span>
//                 <span className="practice-details-info-value">{practiceData.address_line_1 || 'N/A'}</span>
//               </div>

//               <div className="practice-details-info-row">
//                 <span className="practice-details-info-label">Email</span>
//                 <span className="practice-details-info-separator">:</span>
//                 <span className="practice-details-info-value">{practiceData.email_1 || 'N/A'}</span>
//               </div>

//               <div className="practice-details-info-row">
//                 <span className="practice-details-info-label">Phone 1</span>
//                 <span className="practice-details-info-separator">:</span>
//                 <span className="practice-details-info-value">{practiceData.phone_1 || 'N/A'}</span>
//               </div>

//               <div className="practice-details-info-row">
//                 <span className="practice-details-info-label">Phone 2</span>
//                 <span className="practice-details-info-separator">:</span>
//                 <span className="practice-details-info-value">{practiceData.phone_2 || 'N/A'}</span>
//               </div>

//               <div className="practice-details-info-row">
//                 <span className="practice-details-info-label">Fax</span>
//                 <span className="practice-details-info-separator">:</span>
//                 <span className="practice-details-info-value">{practiceData.fax_1 || 'N/A'}</span>
//               </div>

//               <div className="practice-details-info-row">
//                 <span className="practice-details-info-label">RPM Start Date</span>
//                 <span className="practice-details-info-separator">:</span>
//                 <span className="practice-details-info-value">
//                   {practiceData.rpm_start_date ? 
//                     new Date(practiceData.rpm_start_date).toLocaleDateString('en-US', {
//                       month: '2-digit',
//                       day: '2-digit',
//                       year: 'numeric'
//                     }) : 'N/A'}
//                 </span>
//               </div>

//               <div className="practice-details-info-row">
//                 <span className="practice-details-info-label">RPM End Date</span>
//                 <span className="practice-details-info-separator">:</span>
//                 <span className="practice-details-info-value">
//                   {practiceData.rpm_end_date ? 
//                     new Date(practiceData.rpm_end_date).toLocaleDateString('en-US', {
//                       month: '2-digit',
//                       day: '2-digit',
//                       year: 'numeric'
//                     }) : 'N/A'}
//                 </span>
//               </div>

//               <div className="practice-details-info-row">
//                 <span className="practice-details-info-label">Status</span>
//                 <span className="practice-details-info-separator">:</span>
//                 <span className="practice-details-info-value">
//                   <span className={`status-badge ${getStatusBadgeClass(practiceData.status)}`}>
//                     {practiceData.status || 'N/A'}
//                   </span>
//                 </span>
//               </div>
//             </div>
//           </div>

//           {/* Secondary Contact */}
//           <div className="col-md-6">
//             <div className="practice-details-contact-card">
//               <h5>Secondary Contact</h5>

//               <div className="practice-details-info-row">
//                 <span className="practice-details-info-label">Facility</span>
//                 <span className="practice-details-info-separator">:</span>
//                 <span className="practice-details-info-value">{practiceData.address_line_2 || 'N/A'}</span>
//               </div>

//               <div className="practice-details-info-row">
//                 <span className="practice-details-info-label">Email</span>
//                 <span className="practice-details-info-separator">:</span>
//                 <span className="practice-details-info-value">{practiceData.email_2 || 'N/A'}</span>
//               </div>

//               <div className="practice-details-info-row">
//                 <span className="practice-details-info-label">Phone 1</span>
//                 <span className="practice-details-info-separator">:</span>
//                 <span className="practice-details-info-value">{practiceData.phone_2 || 'N/A'}</span>
//               </div>

//               <div className="practice-details-info-row">
//                 <span className="practice-details-info-label">Phone 2</span>
//                 <span className="practice-details-info-separator">:</span>
//                 <span className="practice-details-info-value">{practiceData.phone_1 || 'N/A'}</span>
//               </div>

//               <div className="practice-details-info-row">
//                 <span className="practice-details-info-label">Fax</span>
//                 <span className="practice-details-info-separator">:</span>
//                 <span className="practice-details-info-value">{practiceData.fax_1 || 'N/A'}</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Monitoring Details Section */}
//       <div className="practice-details-monitoring-section">
//         <div className="practice-details-monitoring-card">
//           <h5>Monitoring Details</h5>

//           <div className="row">
//             <div className="col-md-6">
//               <div className="practice-details-monitoring-row">
//                 <span className="practice-details-monitoring-question">Do you want codexterlabs to Monitor your patients</span>
//                 <span className="practice-details-monitoring-answer">
//                   <span className="practice-details-info-separator">:</span>
//                   {practiceData.monitor_to_patient ? 'Yes' : 'No'}
//                 </span>
//               </div>

//               <div className="practice-details-monitoring-row">
//                 <span className="practice-details-monitoring-question">Patients To Be Monitored</span>
//                 <span className="practice-details-monitoring-answer">
//                   <span className="practice-details-info-separator">:</span>
//                   <span className="practice-details-monitoring-types">
//                     {practiceData.selected_monitoring_types && practiceData.selected_monitoring_types.length > 0 ? (
//                       practiceData.selected_monitoring_types.map((type, index) => {
//                         const typeNames = {
//                           1: 'Blood Pressure',
//                           2: 'Blood Glucose', 
//                           3: 'Weight'
//                         };
//                         return (
//                           <span key={index} className="practice-details-monitoring-type-badge">
//                             {typeNames[type] || `Type ${type}`}
//                           </span>
//                         );
//                       })
//                     ) : 'N/A'}
//                   </span>
//                 </span>
//               </div>
//             </div>

//             <div className="col-md-6">
//               <div className="practice-details-monitoring-row">
//                 <span className="practice-details-monitoring-question">Buying Device</span>
//                 <span className="practice-details-monitoring-answer">
//                   <span className="practice-details-info-separator">:</span>
//                   {practiceData.buying_listing_device ? 'Yes' : 'No'}
//                 </span>
//               </div>

//               <div className="practice-details-monitoring-row">
//                 <span className="practice-details-monitoring-question">Leasing Device</span>
//                 <span className="practice-details-monitoring-answer">
//                   <span className="practice-details-info-separator">:</span>
//                   {practiceData.leasing_listing_device ? 'Yes' : 'No'}
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PracticeDetails;
import React from 'react';
import '../PracticesList/AddPractice/AddPractice.css';
import './PracticeDetails.css';
import { resolvePracticeLogoUrl } from '../../../utils/assetUrls';

const PracticeDetails = ({ practiceData }) => {
  if (!practiceData) {
    return (
      <div className="practice-details-alert practice-details-alert-info" role="alert">
        No practice data available.
      </div>
    );
  }

  // Get status color based on status
  const getStatusColor = (status) => {
    if (!status || typeof status !== 'string') {
      return 'inherit';
    }
    switch (status.toLowerCase()) {
      case 'active':
        return 'green';
      case 'pending':
        return '#FFC107'; // Yellow
      case 'inactive':
        return 'red';
      default:
        return 'inherit';
    }
  };

  // Get logo URL - construct full URL if logo path exists
  const getLogoUrl = () => {
    return resolvePracticeLogoUrl(practiceData.practice_logo, {
      cacheBust: practiceData.updated_at || practiceData.id || 'practice-logo'
    });
  };

  const logoUrl = getLogoUrl();
  const primaryAddress = practiceData.primary_address || {};
  const secondaryAddress = practiceData.secondary_address || {};

  const primaryFacility = practiceData.address_line_1 || primaryAddress.address_line_1 || 'N/A';
  const primaryEmail = practiceData.email_1 || primaryAddress.email || 'N/A';
  const primaryPhone1 = practiceData.phone_1 || primaryAddress.phone || 'N/A';
  const primaryPhone2 = practiceData.phone_2 || primaryAddress.cell_phone || 'N/A';
  const primaryFax = practiceData.fax_1 || primaryAddress.fax || 'N/A';

  const secondaryFacility = practiceData.address_2 || secondaryAddress.address_line_1 || 'N/A';
  const secondaryEmail = practiceData.email_2 || secondaryAddress.email || 'N/A';
  const secondaryPhone1 = practiceData.phone_secondary_1 || secondaryAddress.phone || 'N/A';
  const secondaryPhone2 = practiceData.phone_secondary_2 || secondaryAddress.cell_phone || 'N/A';
  const secondaryFax = practiceData.fax_2 || secondaryAddress.fax || 'N/A';

  return (
    <div className="practice-details">
      {/* Primary and Secondary Contact Section */}
      <div className="practice-details-contact-section">
        <div className="row g-3">
          {/* Primary Contact */}
          <div className="col-md-6 d-flex">
            <div className="add-practice-section-card practice-details-add-section flex-fill">
              <h5 className="add-practice-section-header">Primary Contact</h5>

              <div className="practice-details-info-row">
                <span className="practice-details-info-label">Facility</span>
                <span className="practice-details-info-separator">:</span>
                <span className="practice-details-info-value">{primaryFacility}</span>
              </div>

              <div className="practice-details-info-row">
                <span className="practice-details-info-label">Email</span>
                <span className="practice-details-info-separator">:</span>
                <span className="practice-details-info-value">{primaryEmail}</span>
              </div>

              <div className="practice-details-info-row">
                <span className="practice-details-info-label">Phone 1</span>
                <span className="practice-details-info-separator">:</span>
                <span className="practice-details-info-value">{primaryPhone1}</span>
              </div>

              <div className="practice-details-info-row">
                <span className="practice-details-info-label">Phone 2</span>
                <span className="practice-details-info-separator">:</span>
                <span className="practice-details-info-value">{primaryPhone2}</span>
              </div>

              <div className="practice-details-info-row">
                <span className="practice-details-info-label">Fax</span>
                <span className="practice-details-info-separator">:</span>
                <span className="practice-details-info-value">{primaryFax}</span>
              </div>

              <div className="practice-details-info-row">
                <span className="practice-details-info-label">RPM Start Date</span>
                <span className="practice-details-info-separator">:</span>
                <span className="practice-details-info-value">
                  {practiceData.rpm_start_date ?
                    new Date(practiceData.rpm_start_date).toLocaleDateString('en-US', {
                      month: '2-digit',
                      day: '2-digit',
                      year: 'numeric'
                    }) : 'N/A'}
                </span>
              </div>

              <div className="practice-details-info-row">
                <span className="practice-details-info-label">RPM End Date</span>
                <span className="practice-details-info-separator">:</span>
                <span className="practice-details-info-value">
                  {practiceData.rpm_end_date ?
                    new Date(practiceData.rpm_end_date).toLocaleDateString('en-US', {
                      month: '2-digit',
                      day: '2-digit',
                      year: 'numeric'
                    }) : 'N/A'}
                </span>
              </div>

              <div className="practice-details-info-row">
                <span className="practice-details-info-label">Status</span>
                <span className="practice-details-info-separator">:</span>
                <span
                  className="practice-details-info-value"
                  style={{
                    color: getStatusColor(practiceData.status),
                    fontWeight: '600'
                  }}
                >
                  {practiceData.status || 'N/A'}
                </span>
              </div>
            </div>
          </div>

          {/* Secondary Contact */}
          <div className="col-md-6 d-flex">
            <div className="add-practice-section-card practice-details-add-section flex-fill">
              <h5 className="add-practice-section-header">Secondary Contact</h5>

              <div className="practice-details-info-row">
                <span className="practice-details-info-label">Facility</span>
                <span className="practice-details-info-separator">:</span>
                <span className="practice-details-info-value">{secondaryFacility}</span>
              </div>

              <div className="practice-details-info-row">
                <span className="practice-details-info-label">Email</span>
                <span className="practice-details-info-separator">:</span>
                <span className="practice-details-info-value">{secondaryEmail}</span>
              </div>

              <div className="practice-details-info-row">
                <span className="practice-details-info-label">Phone 1</span>
                <span className="practice-details-info-separator">:</span>
                <span className="practice-details-info-value">{secondaryPhone1}</span>
              </div>

              <div className="practice-details-info-row">
                <span className="practice-details-info-label">Phone 2</span>
                <span className="practice-details-info-separator">:</span>
                <span className="practice-details-info-value">{secondaryPhone2}</span>
              </div>

              <div className="practice-details-info-row">
                <span className="practice-details-info-label">Fax</span>
                <span className="practice-details-info-separator">:</span>
                <span className="practice-details-info-value">{secondaryFax}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Monitoring Details Section */}
      <div className="practice-details-monitoring-section">
        <div className="add-practice-section-card practice-details-add-section practice-details-add-section--wide">
          <h5 className="add-practice-section-header">Monitoring Details</h5>

          <div className="row">
            <div className="col-md-6">
              <div className="practice-details-monitoring-row">
                <span className="practice-details-monitoring-question">Do you want Codexterlabs to Monitor your patients</span>
                <span className="practice-details-monitoring-answer">
                  <span className="practice-details-info-separator">:</span>
                  {practiceData.monitor_to_patient ? 'Yes' : 'No'}
                </span>
              </div>

              <div className="practice-details-monitoring-row practice-details-monitoring-row--inline-types">
                <span className="practice-details-monitoring-question">Patients To Be Monitored</span>
                <span className="practice-details-monitoring-answer">
                  <span className="practice-details-info-separator">:</span>
                  <span className="practice-details-monitoring-types">
                    {practiceData.selected_monitoring_types && practiceData.selected_monitoring_types.length > 0 ? (
                      practiceData.selected_monitoring_types.map((type, index) => {
                        const typeNames = {
                          1: 'Blood Pressure',
                          2: 'Blood Glucose',
                          3: 'Weight'
                        };
                        return (
                          <span key={index} className="practice-details-monitoring-type-badge">
                            {typeNames[type] || `Type ${type}`}
                          </span>
                        );
                      })
                    ) : 'N/A'}
                  </span>
                </span>
              </div>
            </div>

            <div className="col-md-6">
              <div className="practice-details-monitoring-row">
                <span className="practice-details-monitoring-question">Buying Device</span>
                <span className="practice-details-monitoring-answer">
                  <span className="practice-details-info-separator">:</span>
                  {practiceData.buying_listing_device ? 'Yes' : 'No'}
                </span>
              </div>

              <div className="practice-details-monitoring-row">
                <span className="practice-details-monitoring-question">Leasing Device</span>
                <span className="practice-details-monitoring-answer">
                  <span className="practice-details-info-separator">:</span>
                  {practiceData.leasing_listing_device ? 'Yes' : 'No'}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PracticeDetails;